// Store references to launcher elements so we can restore their visibility
const storedLaunchers: HTMLElement[] = [];
// Store references to iframes we hide so we can restore their visibility
const storedIframes: HTMLIFrameElement[] = [];

/**
 * Hides the Unit.co chatbot launcher (#launcher) and all iframes so they stay in the DOM but are not visible.
 * We do this in the main document, any top-level iframes, and shadow roots.
 */
export function removeUnitCoLauncher(): void {
  // Clear previous references
  storedLaunchers.length = 0;
  storedIframes.length = 0;

  // 0. All iframes in the main document — hide and store for restore
  try {
    const iframes = document.body?.querySelectorAll?.('iframe') ?? [];
    iframes.forEach((iframe) => {
      const el = iframe as HTMLIFrameElement;
      el.style.visibility = 'hidden';
      storedIframes.push(el);
    });
  } catch (_) {
    // ignore
  }

  // 1. Main document
  try {
    const mainLauncher = document.getElementById('launcher');
    if (mainLauncher) {
      const el = mainLauncher as HTMLElement;
      el.style.visibility = 'hidden';
      storedLaunchers.push(el);
    }
  } catch (_) {
    // ignore
  }

  // 2. Inside top-level iframes (main-doc -> iframe -> nested doc -> #launcher)
  try {
    const iframes = document.body?.querySelectorAll?.('iframe') ?? [];
    iframes.forEach((iframe) => {
      try {
        const doc = (iframe as HTMLIFrameElement).contentDocument;
        if (doc) {
          const launcher = doc.getElementById('launcher');
          if (launcher) {
            const el = launcher as HTMLElement;
            el.style.visibility = 'hidden';
            storedLaunchers.push(el);
          }
        }
      } catch (_) {
        // cross-origin or other
      }
    });
  } catch (_) {
    // ignore
  }

  // 3. Inside shadow roots (main-doc -> host with shadow -> #launcher)
  try {
    const walker = document.body?.querySelectorAll?.('*') ?? [];
    walker.forEach((el) => {
      try {
        if (el.shadowRoot) {
          const launcher = el.shadowRoot.getElementById('launcher');
          if (launcher) {
            const hostEl = launcher as HTMLElement;
            hostEl.style.visibility = 'hidden';
            storedLaunchers.push(hostEl);
          }
        }
      } catch (_) {
        // ignore
      }
    });
  } catch (_) {
    // ignore
  }
}

/**
 * Restores visibility of any launcher elements and iframes we previously hid.
 */
export function restoreUnitCoLauncher(): void {
  try {
    storedLaunchers.forEach((el) => {
      try {
        el.style.visibility = 'visible';
      } catch (_) {
        // ignore
      }
    });
    storedLaunchers.length = 0;
    storedIframes.forEach((el) => {
      try {
        el.style.visibility = 'visible';
      } catch (_) {
        // ignore
      }
    });
    storedIframes.length = 0;
  } catch (_) {
    // ignore
  }
}
